<template>
  <div
    v-if="!isScreenSmall"
    class="wds-container"
  >
    <div class="wds-grid">
      <div class="wds-grid__col--12 wds-grid__col ds-margin-bottom-48">
        <div class="ds-display-flex ds-flex-direction-column">
          <h2 class="ds-heading">
            {{ title }}
          </h2>
        </div>
      </div>

      <div
        v-for="(item, index) in items"
        :key="`item-${index}`"
        class="wds-grid__col--3 wds-grid__col"
      >
        <DsCardLinkMedia
          :slot="['image-gallery-item', index + 1].join('-')"
          :link="item.link"
          :media-height="400"
        >
          <template #media>
            <DsImageElement
              :image="item.imageWithSizes"
              :screen="screen"
              aspect-ratio="3/4"
            />
          </template>
          <!-- <div slot="media">
          </div> -->
        </DsCardLinkMedia>
      </div>
    </div>
  </div>
  <div v-else>
    <DsImageGallery
      :screen="screen"
      :items="items.length"
      :width="{ small: 260, large: 260 }"
      :title="title"
      type="tertiary"
      class="kh-popular-topics"
    >
      <template #default="{ index }">
        <DsCardLinkMedia
          v-if="items[index - 1]"
          :link="items[index - 1].link"
          :media-height="350"
        >
          {{ items }}
          <template #media>
            <DsImageElement
              :image="items[index - 1].imageWithSizes"
              :screen="screen"
              aspect-ratio="3/4"
            />
          </template>
        </DsCardLinkMedia>
      </template>
    </DsImageGallery>
  </div>
</template>
<script setup>
import { DsImageElement, DsImageGallery, DsCardLinkMedia } from 'awds'
const { isScreenSmall, screen } = useScreen()

/**
 * Knowledge Hub Popular Topics Component
 *
 * @example
 * ```js
 * import KnowledgeHubPopularTopics from '@/components/knowledge-hub/knowledge-hub-popular-topics.vue'
 *
 * export default {
 *   components: { KnowledgeHubPopularTopics },
 *   template: `<div>
 *     <KnowledgeHubPopularTopics
 *        :items="popularTopics"
 *        :title="popularTopicsTitle"
 *      />
 *     />
 *   </div>`
 * }
 * ```
 */
defineProps({
  items: {
    type: Array,
    default: () => []
  },
  title: {
    type: String,
    default: () => ''
  }
})
</script>
